import HomeRoundedIcon from "@mui/icons-material/HomeRounded";

export const home = (props) => {
  return <HomeRoundedIcon {...props} />;
};
